<template>
    <transition name="fade">
        <div class="single-item__stock-outer"
             v-if="currentVariation && currentVariation.stock.net < 11"
             key="transition--stock">
            <transition name="fade" mode="out-in">
                <div class="d-flex justify-content-center justify-content-lg-start" :key="'transition--stock-'+currentVariation.stock.net">
                    <div class="single-item__stock-wrapper">
                        <span v-if="currentVariation.stock.net === 0">
                            Der Artikel ist aktuell nicht auf Lager
                        </span>
                        <span v-else>
                            Nur noch {{ currentVariation.stock.net }} Artikel auf Lager
                        </span>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    inject: {
        itemId: {
            default: null
        }
    },
    computed: {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        }
    }
}
</script>
